import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PravnoNormiranjePM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Pravno normiranje" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Pravno normiranje</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Pravno normiranje
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong>{" "}
              </p>
              <p>
                <strong>Broj ECTS:</strong>{" "}
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Pravno normiranje je da pripremi studente za naučno zasnovano
                normiranje pravnih propisa kako heteronomnih tako i autonomnih.
                Usvajanje znanja o temeljnim pojmovima pravnog normiranja u
                pogledu postupka i načina donošenja pravnih propisa kao i
                upoznavanje sa aktima koje donose određene institucije Europske
                unije. Takođe cilj ovog predmeta je i izučavanje osnovnih
                principa koji se koriste prilikom izrade pravnih akata,
                upoznavanje studenata sa standardima jezičke kulture u pravu kao
                i unaprijeđivanje pravnog vokabulara studenata.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Uspješnim savladavanjem nastavnog gradiva student će steći
                praktična znanja za primjenu pravila normiranja i izradu
                kvalitetnih pravnih propisa. Studenti će se takođe upoznati sa
                metodama nomotehnike i osposobiti da u odnosu na potrebe
                upotrijebe najpodobniji metod normiranja. Takođe studenti će
                steći tehniku pravnog istraživanja i sposobnost pravničkog
                rezonovanja. S obzirom da je proces izrade donošenja pravnih
                akata često kolegijalne prirode, studenti će razviti sposobnosti
                timskog rada uz naravno i razvijanje samostalnosti u radu i
                izradi pravnih akata. Takođe student će biti osposobljen za
                lektorisanje i redakciju pravnih tekstova.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Pravno normiranje: pojam i predmet; Pravna tehnika; Pravila za
                izradu zakona i drugih propisa; Metod stvaranje prava: pojam i
                metod; Pravni oblik; Tehničke metode stvaranja prava:
                apstraktna, načelna, taksativna, primjerična, sociološka,
                politička, aksiološka, dogmatična, normativna, istorijskopravna,
                uporednopravna metoda; Stil i način pisanja propisa; Jasnoća,
                preciznost i izbor jezika; Pojam i metode primjene prava; Stil i
                pravopis u propisima; Gramatika u propisima; Zakonodavstvo i
                kodifikacija; Zakonodavni postupak; Proglašenje i objavljivanje
                zakona; Izmjene i dopune propisa; Prečišćeni tekst; Ispravke
                propisa; Autentično tumačenje; Donošenje zakona u Skupštini Crne
                Gore; Struktura i sistematika podzakonskih propisa; Hijerarhija
                opštih akata; Normiranje opštih akata; Rokovi, vrijeme i jezik u
                opštim aktima; Struktura opštih akata; Struktura podzakonskih
                akata; Pojam, obilježja i značaj autonomnog prava; Odnos
                državnog i autonomnog prava.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja i vježbe, seminarski rad, kolokvijumi, završni ispit.
                Interaktivna nastava koja obuhvata uvodno izlaganje od strane
                predavača i učešće studenta; Predavanja i vježbe praćena su
                odgovarajućim posebno izrađenim prezentacijama. Analiza sudske i
                arbitražne prakse; rešavanje hipotetičkih slučajeva.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>Pravno normiranje: pojam i predmet; Pravna tehnika;</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Pravila za izradu zakona i drugih propisa; Metod stvaranje
                      prava: pojam i metod; Pravni oblik;
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Tehničke metode stvaranja prava: apstraktna, načelna,
                      taksativna, primjerična, sociološka, politička,
                      aksiološka, dogmatična, normativna, istorijskopravna,
                      uporednopravna metoda;
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Stil i način pisanja propisa; Jasnoća, preciznost i izbor
                      jezika;
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Pojam i metodi primjene prava; Stil i pravopis u
                      propisima; Gramatika u propisima
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>Zakonodavstvo i kodifikacija; Zakonodavni postupak;</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Proglašenje i objavljivanje zakona; Izmjene i dopune
                      propisa; Prečišćeni tekst; Ispravke propisa;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>
                      Autentično tumačenje; Donošenje zakona u Skupštini Crne
                      Gore;
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>
                      Struktura i sistematika podzakonskih propisa; Hijerarhija
                      opštih akata;
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>
                      Normiranje opštih akata; Rokovi, vrijeme i jezik u opštim
                      aktima;
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>Struktura opštih akata;</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>Struktura podzakonskih akata;</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>
                      Pojam, obilježja i značaj autonomnog prava; Odnos državnog
                      i autonomnog prava;
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6č / 4.3h</td>
                            <td>Ukupno: 120h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4č / 3.00h</td>
                            <td>Nastava + završni ispit: 90h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PravnoNormiranjePM;
